/**
 * @deprecated AgreementType IDs are institution-specific. Use configuration from the database instead of hardcoded enum values.
 */
export enum AgreementTypeEnum {
  Permanent = 1,
  FixedTerm = 2,
  Trial = 3,
  Temporary = 10,
}
